module.exports = __webpack_public_path__ + "img/1-3.6b5a6012.jpg";